import Type from 'prop-types';
import defaultCellRenderer from './defaultCellRenderer';
import defaultCellDataGetter from './defaultCellDataGetter';
import defaultHeaderRenderer from './defaultHeaderRenderer';

const COLUMN_WIDTH = 100;

const Column = () => {};

Column.propTypes = {
  dataKey: Type.oneOfType([Type.string, Type.number]).isRequired,
  cellDataGetter: Type.func,
  cellRenderer: Type.func,
  columnData: Type.object, // eslint-disable-line react/forbid-prop-types
  className: Type.string,
  label: Type.node,
  width: Type.number,
  headerRenderer: Type.func,
  headerClassName: Type.string,
  formatter: Type.func,
  headerStyle: Type.object, // eslint-disable-line react/forbid-prop-types
  style: Type.object, // eslint-disable-line react/forbid-prop-types
};

Column.defaultProps = {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  headerRenderer: defaultHeaderRenderer,
  width: COLUMN_WIDTH,
  style: {},
};

export default Column;
